export default {
    apiKey: "AIzaSyAtaW81gTr6TDRjjo2YfsVO01sY4WdeyD0",
    authDomain: "mygitapp-da4a1.firebaseapp.com",
    databaseURL: "https://mygitapp-da4a1.firebaseio.com",
    projectId: "mygitapp-da4a1",
    storageBucket: "mygitapp-da4a1.appspot.com",
    messagingSenderId: "1088193364388",
    appId: "1:1088193364388:web:9c4c97d59c941da9e08131",
    measurementId: "G-3LXH8QMQQM"
};